import { ExtPerson, Person } from 'services/SwaggerApi';

export const isExtPerson = (person: ExtPerson | Person): person is ExtPerson => {
    return Boolean((person as ExtPerson).ext_person_uuid);
};
